export default "__VITE_ASSET__DGNT5nsL__"